import { DynamicLoader, StackUtil, StringUtil } from "@mcleod/core";
import { CommonDialogs } from "../../../../common/src/CommonDialogs";
import { Dialog, DialogProps } from "../Dialog";
import { DisplayedLayoutInfo } from "../DisplayedLayoutInfo";
import { LabelProps } from "../../components/label/LabelProps";
import { Layout } from "../../components/layout/Layout";
import { ReflectiveDialogs } from "../../base/ReflectiveDialogs";

export class StackDialog {
    public static async showStackDialog(error: Error, dialogProps: Partial<DialogProps>, sourceLayout?: Layout):
    Promise<Dialog> {
        const stackLabels: Partial<LabelProps>[] = [];
        StackUtil.mapStackTrace(error.stack, (stackElements) => {
            stackElements?.forEach(stackElement => this.generateStackLineLabels(stackElement, stackLabels));
        });
        const allContent = [ ...stackLabels ];
        const displayedLayoutInfo = new DisplayedLayoutInfo(sourceLayout, { marginTop: 16 });
        if (!displayedLayoutInfo.isEmpty()) {
            allContent.push(displayedLayoutInfo);
        }
        const dialogPropsWithScroll = {
            ...dialogProps,
            panelContentProps: { ...dialogProps.panelContentProps, scrollY: true },
            panelTitleProps: { ...dialogProps.panelTitleProps, ...CommonDialogs.errorHeaderThemeObject }
        }
        return ReflectiveDialogs.showDialog(allContent, dialogPropsWithScroll);
    }

    // The stackElement variable is really an object satisfying the StackElement interface
    private static generateStackLineLabels(stackElement: any, stackLabels: Partial<LabelProps>[]) {
        const commonProps = { padding: 0, marginBottom: 4 }
        stackLabels.push({ text: stackElement.text, rowBreak: stackElement.file == null, marginRight: 4, ...commonProps });
        if (stackElement.file != null) {
            stackLabels.push({ text: "(", rowBreak: false, ...commonProps })
            stackLabels.push({
                text: StringUtil.stringAfterLast(stackElement.file, "/") + ":" + stackElement.line,
                color: "primary",
                ...commonProps,
                borderBottomWidth: 1,
                rowBreak: false,
                onClick: () => {
                    // It's not valid to have a static import to designer from here, so look it up dynamically
                    const codeEditor = DynamicLoader.getClassForPath("designer/common/CodeEditor");
                    if (codeEditor != null) {
                        codeEditor.openCodeEditor(stackElement.file,
                            { line: stackElement.line, col: stackElement.col + 1 });
                    }
                }
            });
            stackLabels.push({ text: ")", ...commonProps })
        }
    }
}
